"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggle = void 0;
exports.toggle = {
    path: "M2 0C0.895431 0 0 0.89543 0 2V12C0 13.1046 0.89543 14 2 14H12C13.1046 14 14 13.1046 14 12V2C14 0.895431 13.1046 0 12 0H2ZM5 2C4.44772 2 4 2.44772 4 3V11C4 11.5523 4.44772 12 5 12C5.55228 12 6 11.5523 6 11V3C6 2.44772 5.55228 2 5 2Z",
    originalWidth: 14,
    originalHeight: 14,
    basicColor: "tableGray2",
    activeColor: "tableBlack2"
};
